import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handleGetRequest } from "../../../services/GetTemplate"; // Import the GET request function
import { Dialog } from "primereact/dialog"; // Import Dialog component

const Wallet = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const [data, setData] = useState(null); // State to store wallet information
    const [paymentGateways, setPaymentGateways] = useState([]); // State to store payment gateways
    const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility
    const [otpDialogVisible, setOtpDialogVisible] = useState(false); // State to control OTP dialog visibility
    const inputRefs = useRef([]);
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.authenticationSlice?.userId);
    const mobileNumber = JSON.parse(localStorage.getItem("loginData"))?.data?.mobile;
    console.log("Mobile Number:", mobileNumber);

    const fetchWalletInfo = async () => {
        try {
            console.log("Fetching wallet info...");
            const response = await dispatch(handlePostRequest("api/user/getWalletInfo", { userId }, true, true));
            if (response?.data) {
                console.log("Wallet Info:", response.data);
                setData(response.data);
            } else {
                console.warn("Response missing data:", response);
            }
        } catch (error) {
            console.error("Error fetching wallet info:", error);
        }
    };

    useEffect(() => {
        if (userId) {
            fetchWalletInfo();
        } else {
            console.warn("User ID is undefined");
        }
    }, [dispatch, userId]);

    const handleConvert = async () => {
        setSaveBtnLoading(true);
        try {
            const response = await dispatch(handleGetRequest("api/paymentGateway/getPaymentGatewayList", {}, true, true));
            if (response?.data) {
                console.log("Payment Gateways:", response.data);
                setPaymentGateways(response.data);
                setIsModalVisible(true);
            } else {
                console.warn("Response missing data:", response);
            }
        } catch (error) {
            console.error("Error fetching payment gateways:", error);
        } finally {
            setSaveBtnLoading(false);
        }
    };

    const handleDeLink = async () => {
        setSaveBtnLoading(true);
        try {
            const response = await dispatch(handlePostRequest("api/user/zindigiwalletOTP", { userId }, true, true));
            if (response?.status === 200) {
                console.log("OTP sent successfully:", response);
                toast.success("OTP sent successfully");
                setOtpDialogVisible(true); // Show OTP dialog
            } else {
                console.warn("Failed to send OTP:", response);
                toast.error("Failed to send OTP");
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            toast.error("Error sending OTP");
        } finally {
            setSaveBtnLoading(false);
        }
    };

    const otpValidationSchema = Yup.object({
        OTP: Yup.array()
            .of(Yup.string().matches(/^[0-9]?$/, "Each field must be a single digit."))
            .test("all-filled", "All fields must be filled and valid.", (values) => values.every((value) => /^[0-9]$/.test(value))),
    });

    const otpFormik = useFormik({
        validationSchema: otpValidationSchema,
        initialValues: { OTP: ["", "", "", ""] },
        onSubmit: async ({ OTP }) => {
            const otpPin = OTP.join("");
            const payload = {
                userId,
                OTP: otpPin,
            };
            try {
                const response = await dispatch(handlePostRequest("api/user/unlinkZindigiAccount", payload, true, true));
                if (response?.status === 200) {
                    toast.success("Account unlinked successfully");
                    setOtpDialogVisible(false);
                    fetchWalletInfo(); // Fetch wallet info after unlinking
                } else {
                    toast.error("Failed to unlink account");
                }
            } catch (error) {
                console.error("Error unlinking account:", error);
                toast.error("Error unlinking account");
            }
        },
    });

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^[0-9]$/.test(value) && value !== "") return;

        const otp = [...otpFormik.values.OTP];
        otp[index] = value;
        otpFormik.setFieldValue("OTP", otp);
        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        const { key } = e;
        if (key === "ArrowLeft" && index > 0) {
            inputRefs?.current[index - 1]?.focus();
        } else if (key === "ArrowRight" && index < inputRefs?.current?.length - 1) {
            inputRefs?.current[index + 1]?.focus();
        } else if (key === "Backspace") {
            const otp = [...otpFormik.values.OTP];
            if (otp[index] === "" && index > 0) {
                inputRefs?.current[index - 1]?.focus();
            } else {
                otp[index] = "";
                otpFormik.setFieldValue("OTP", otp);
            }
        }
    };

    const getOtpFormErrorMessage = () => otpFormik.errors.OTP && otpFormik.touched.OTP && <small className="p-error">{otpFormik.errors.OTP}</small>;

    const validationSchema = Yup.object().shape({
        mobileNo: Yup.mixed().required("This field is required."),
        cnic: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            mobileNo: "",
            cnic: "",
        },
        onSubmit: async (data) => {
            setSaveBtnLoading(true);
            const payload = {
                userId,
                mobileNo: data.mobileNo,
                cnic: data.cnic,
            };
            try {
                const response = await dispatch(handlePostRequest("api/zindigi/verifyAccountToLink", payload, false, false));
                if (response) {
                    // history.push({
                    //     pathname: '/otppp',
                    //     state: { userId:userId, corporateCode: data?.corporateCode }
                    // })
                } else {
                    // Handle unsuccessful response
                }
                setSaveBtnLoading(false);
            } catch (error) {
                console.error(error);
                setSaveBtnLoading(false);
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleRedeem = async () => {
        try {
            const amount = data?.data?.walletInfo?.wallet?.amount;
            if (amount === 0) {
                toast.warn("Amount is zero, cannot redeem");
                return;
            }
            const response = await dispatch(handlePostRequest("api/user/redeemPoints", { userId, amount }, true, true));
            if (response?.status === 200) {
                toast.success("Points redeemed successfully");
                fetchWalletInfo(); // Refresh wallet info after redeeming points
            } else {
                toast.error("Failed to redeem points");
            }
        } catch (error) {
            console.error("Error redeeming points:", error);
            toast.error("Error redeeming points");
        }
    };

    const [selectedGateway, setSelectedGateway] = useState(null); // State to store selected payment gateway
    const [numericInputDialogVisible, setNumericInputDialogVisible] = useState(false); // State to control numeric input dialog visibility
    const [numericInput, setNumericInput] = useState(""); // State to store numeric input

    const handleGatewaySelect = (gateway) => {
        setSelectedGateway(gateway);
        setIsModalVisible(false);
        setNumericInputDialogVisible(true);
    };

    const handleNumericInputChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setNumericInput(value);
        }
    };

    const handleNumericInputSubmit = async () => {
        if (!numericInput || !selectedGateway) {
            toast.error("Please enter a valid amount and select a payment gateway");
            return;
        }

        const availableAmount = data?.data?.walletInfo?.wallet?.amount;
        if (parseFloat(numericInput) > availableAmount) {
            toast.error("Entered amount exceeds available balance");
            return;
        }

        const payload = {
            amount: numericInput,
            userId,
            paymentGatewayId: selectedGateway._id, // Use _id from the selected gateway
        };

        try {
            const response = await dispatch(handlePostRequest("api/paymentRequest", payload, true, true));
            if (response?.status === 200) {
                toast.success("Payment request submitted successfully");
                setNumericInputDialogVisible(false);
                setNumericInput("");
            } else {
                toast.error("Failed to submit payment request");
            }
        } catch (error) {
            console.error("Error submitting payment request:", error);
            toast.error("Error submitting payment request");
        }
    };

    return (
        <>
            <div className="surface-card p-4 md:m-2">
                <div className="flex align-items-center justify-content-between ">
                    <div className="flex align-items-center cursor-pointer">
                        <div>
                            <p className="mb-1 text-lg font-semibold">{data?.data?.walletInfo ? `${data?.data?.walletInfo.firstName}  ${data?.data?.walletInfo.lastName}` : "Loading..."}</p>
                            {/* <Rating value={3} readOnly cancel={false} /> */}
                            <p className="mb-3 ml-2 font-semibold text-lg">{mobileNumber}</p>
                        </div>
                    </div>
                    <div className={`align-items-center cursor-pointer ${data?.data?.walletInfo?.wallet?.amount === 0 ? "disabled" : ""}`} onClick={data?.data?.walletInfo?.wallet?.amount !== 0 ? handleRedeem : null}>
                        <p className="mb-1 text-lg font-semibold">Redeem</p>
                        <p className="flex justify-content-around align-items-center text-lg font-semibold">
                            <span className="text-sm">{data?.data?.walletInfo?.wallet?.currency}</span>
                            {data?.data?.walletInfo?.wallet?.amount}
                        </p>
                    </div>
                </div>
                {/* <hr /> */}

                <div className="flex  my-4">
                    {/* <div className="flex align-items-center flex-column mr-2 my-1">
                        <i className="block text-lg pi pi-circle"></i>
                        <span className="map-border-line"></span>
                        <i className="block text-lg pi pi-map-marker"></i>
                    </div> */}
                    <div>
                        {/* <p className="mb-3 ml-2 font-semibold text-lg">{mobileNumber}</p> */}
                        {/* <p className="mb-0 ml-2 font-semibold text-lg">G10 Markaz</p> */}
                    </div>
                </div>
                <div className="flex align-items-center justify-content-end flex-wrap ml-2">
                    <div className="flex flex-column align-items-center">
                        <p className="mb-1 text-lg font-semibold">Available Balance</p>
                        <p className="flex justify-content-around align-items-center text-lg font-semibold">
                            <span className="text-sm">{data?.data?.walletInfo?.wallet?.currency}</span>
                            {data?.data?.walletInfo?.wallet?.balance}
                        </p>
                    </div>
                </div>
            </div>
            <Button label="Convert" loading={saveBtnLoading} type="button" className="w-full mt-3 mb-3 p-3 text-xl font-medium" onClick={handleConvert} />
            {data?.data?.walletInfo?.zindigiWallet?.linked === true && <Button label="DeLink" loading={saveBtnLoading} type="button" className="w-full mt-3 mb-3 p-3 text-xl font-medium" onClick={handleDeLink} />}

            <Dialog header="Payment Gateways" visible={isModalVisible} style={{ width: "50vw" }} onHide={() => setIsModalVisible(false)}>
                <div>{paymentGateways.length > 0 ? paymentGateways.map((gateway, index) => <Button key={index} label={gateway.name} className="w-full mt-2" onClick={() => handleGatewaySelect(gateway)} />) : <p>No payment gateways available.</p>}</div>
            </Dialog>

            <Dialog header="Enter Amount" visible={numericInputDialogVisible} style={{ width: "30vw" }} onHide={() => setNumericInputDialogVisible(false)}>
                <div className="flex flex-column align-items-center">
                    <label htmlFor="numericInput" className="mb-2">
                        Enter Amount
                    </label>
                    <InputText id="numericInput" value={numericInput} onChange={handleNumericInputChange} className="w-full mb-3" />
                    <Button label="Submit" className="p-button-primary mt-3" onClick={handleNumericInputSubmit} />
                </div>
            </Dialog>

            <Dialog header="OTP Verification" visible={otpDialogVisible} style={{ width: "30vw", background: "blue" }} onHide={() => setOtpDialogVisible(false)}>
                <div className="otp-verification-container flex justify-content-center align-items-center flex-column mt-5">
                    <h2 className="otp-heading mb-3">OTP Verification</h2>
                    <p className="otp-message text-center mb-3">We have sent an OTP to your mobile number</p>
                    <label htmlFor="otp" className="mb-2">
                        Enter the 4-digit SMS OTP
                    </label>
                    <form className="flex flex-column justify-content-center" onSubmit={otpFormik.handleSubmit}>
                        <div className="flex justify-content-center mb-3">
                            {otpFormik.values.OTP.map((value, index) => (
                                <InputText
                                    key={index}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    value={value}
                                    onChange={(e) => handleChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    maxLength={1}
                                    className={`otp-input mr-2 ${otpFormik.errors.OTP && otpFormik.touched.OTP ? "p-invalid" : ""}`}
                                    style={{ width: "40px", textAlign: "center" }}
                                />
                            ))}
                        </div>
                        {getOtpFormErrorMessage()}
                        <Button type="submit" label="Verify" className="p-button-primary mt-3" />
                    </form>
                </div>
            </Dialog>

            {/* <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center overflow-hidden">
                    <div className="login-div-border">
                        <div className="w-full surface-card py-8 px-5 sm:px-6">
                            <div className="text-center mb-5">
                                <img src={ZindigiLogo} alt="Image" height="80" className=" mb-5" />
                                <div className="text-3xl font-medium mb-3" style={{ color: "whitesmoke" }}>
                                    Link Account
                                </div>
                            </div>

                            <div className="login-div">
                                {!showFields ? (
                                    <div className="col-12">
                                        <Button label="Link Account" onClick={() => setShowFields(true)} className="w-full mt-3 mb-3 p-3 text-xl font-medium" />
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <InputText id="mobileNo" type="text" name="mobileNo" placeholder="Enter Phone Number" value={formik.values.mobileNo} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                            {getFormErrorMessage("mobileNo")}
                                        </div>
                                        <div className="mb-3">
                                            <InputText id="cnic" type="text" name="cnic" placeholder="Enter Your CNIC" value={formik.values.cnic} onChange={formik.handleChange} className="w-full mb-2 p-3" />
                                            {getFormErrorMessage("cnic")}
                                        </div>
                                        <Button label="Submit" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-3 p-3 text-xl font-medium" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </form> */}
        </>
    );
};

export default Wallet;
